<app-nav class="w-100"></app-nav>
<section class="banner">
  <div class="container-fluid v4-px-5">
    <div class="d-flex before">
      <div class="d-flex mx-3 align-items-center">
        <h2 class="font-600 v4-color-white">{{ 'Content Experts Management' | translator }}</h2>
      </div>
    </div>
  </div>
</section>

<p-confirmDialog key="experts" [style]="{ width: 'min(460px, 92vw)' }"></p-confirmDialog>

<div class="container-fluid ce-page">
  <nav class="ce-breadcrumb" aria-label="breadcrumb">
    <a routerLink="/home">{{ 'Homepage' | translator }}</a>
    <span aria-hidden="true">/</span>
    <a routerLink="/periodic-reports">{{ 'Periodic Reports' | translator }}</a>
    <span aria-hidden="true">/</span>
    <span>{{ 'Content Experts Management' | translator }}</span>
  </nav>

  <div class="ce-card">
    <!-- Header -->
    <div class="ce-card-header">
      <div>
        <h2 class="ce-title">{{ 'Content Experts Management' | translator }}</h2>
        <p class="ce-subtitle">
          {{ 'Choose who receives and signs the periodic content report of each organizational unit. Only assigned experts appear in the report expert list.' | translator }}
        </p>
      </div>
      <div class="ce-header-actions">
        <button type="button" class="ce-btn ce-btn-outline" (click)="load(true)" [disabled]="loading">
          <i class="pi pi-refresh" [class.pi-spin]="loading"></i>{{ 'Refresh' | translator }}
        </button>
        <button type="button" class="ce-btn ce-btn-outline" routerLink="/periodic-reports">
          <i class="pi pi-arrow-right"></i>{{ 'Back' | translator }}
        </button>
      </div>
    </div>

    <div class="ce-readonly" *ngIf="isReadOnly && !loading">
      <i class="pi pi-lock"></i>
      {{ 'You can view report experts. Changing them requires the content experts management permission.' | translator }}
    </div>

    <!-- Stats -->
    <div class="ce-stats" *ngIf="!loading && !loadError && ous.length > 0">
      <div class="ce-stat">
        <span class="ce-stat-value">{{ ous.length }}</span>
        <span class="ce-stat-label">{{ 'Number of OUs' | translator }}</span>
      </div>
      <div class="ce-stat ce-stat-good">
        <span class="ce-stat-value">{{ coveredOus }}</span>
        <span class="ce-stat-label">{{ 'Units with experts' | translator }}</span>
      </div>
      <div class="ce-stat ce-stat-warn">
        <span class="ce-stat-value">{{ ous.length - coveredOus }}</span>
        <span class="ce-stat-label">{{ 'Units without experts' | translator }}</span>
      </div>
      <div class="ce-stat">
        <span class="ce-stat-value">{{ uniqueExperts }}</span>
        <span class="ce-stat-label">{{ 'Report experts' | translator }}</span>
      </div>
    </div>

    <!-- Loading -->
    <div class="ce-layout" *ngIf="loading">
      <div class="ce-list-pane">
        <p-skeleton height="48px" styleClass="mb-3"></p-skeleton>
        <p-skeleton *ngFor="let i of [1, 2, 3, 4, 5, 6]" height="64px" styleClass="mb-2"></p-skeleton>
      </div>
      <div class="ce-detail-pane">
        <p-skeleton height="40px" width="50%" styleClass="mb-4"></p-skeleton>
        <p-skeleton *ngFor="let i of [1, 2, 3]" height="72px" styleClass="mb-2"></p-skeleton>
      </div>
    </div>

    <!-- Error -->
    <div class="ce-state" *ngIf="!loading && loadError" role="alert">
      <i class="pi pi-exclamation-circle ce-state-icon ce-state-error"></i>
      <h3>{{ 'Could not load report experts' | translator }}</h3>
      <p>{{ 'Check your connection and try again.' | translator }}</p>
      <button type="button" class="ce-btn ce-btn-primary" (click)="load(true)">
        <i class="pi pi-refresh"></i>{{ 'Try again' | translator }}
      </button>
    </div>

    <!-- No OUs -->
    <div class="ce-state" *ngIf="!loading && !loadError && ous.length === 0">
      <i class="pi pi-building ce-state-icon"></i>
      <h3>{{ 'No organizational units available' | translator }}</h3>
      <p>{{ 'You do not have access to any unit that has content reports.' | translator }}</p>
    </div>

    <div class="ce-layout" *ngIf="!loading && !loadError && ous.length > 0">
      <!-- OU list -->
      <aside class="ce-list-pane">
        <div class="ce-search">
          <i class="pi pi-search" aria-hidden="true"></i>
          <input type="search" [(ngModel)]="ouSearch" (ngModelChange)="applyFilters()"
            [attr.aria-label]="'Search units or experts' | translator"
            placeholder="{{ 'Search units or experts' | translator }}" />
          <button *ngIf="ouSearch" type="button" class="ce-search-clear" (click)="clearSearch()"
            [attr.aria-label]="'Clear' | translator">
            <i class="pi pi-times"></i>
          </button>
        </div>

        <div class="ce-filter">
          <button type="button" *ngFor="let opt of coverageOptions" class="ce-chip"
            [class.active]="coverageFilter === opt.value" [attr.aria-pressed]="coverageFilter === opt.value"
            (click)="coverageFilter = opt.value; applyFilters()">
            {{ opt.label }}
          </button>
        </div>

        <div class="ce-list-count">{{ filteredOus.length }} / {{ ous.length }}</div>

        <ul class="ce-ou-list" role="listbox" [attr.aria-label]="'Organizational units' | translator">
          <li *ngFor="let row of filteredOus; trackBy: trackById">
            <button type="button" class="ce-ou-item" role="option" [attr.aria-selected]="selectedOu?._id === row._id"
              [class.selected]="selectedOu?._id === row._id" (click)="selectOu(row)">
              <span class="ce-ou-avatar">
                <img *ngIf="checkisImg(row.image); else ouIcon" [src]="staticURL + row.image" alt="" />
                <ng-template #ouIcon><i class="{{ row.image || 'pi pi-building' }}"></i></ng-template>
              </span>
              <span class="ce-ou-text">
                <span class="ce-ou-name">{{ row.label }}</span>
                <span class="ce-ou-path" *ngIf="row.path">{{ row.path }}</span>
              </span>
              <span class="ce-count" [class.ce-count-empty]="activeCount(row) === 0"
                [pTooltip]="(activeCount(row) === 0 ? 'No experts assigned' : 'Assigned experts') | translator"
                tooltipPosition="top">
                <i class="pi" [ngClass]="activeCount(row) === 0 ? 'pi-exclamation-triangle' : 'pi-user'"></i>
                {{ activeCount(row) }}
              </span>
            </button>
          </li>
        </ul>

        <div class="ce-state ce-state-small" *ngIf="filteredOus.length === 0">
          <i class="pi pi-filter-slash ce-state-icon"></i>
          <p>{{ 'No units match your search' | translator }}</p>
        </div>
      </aside>

      <!-- Selected OU -->
      <section class="ce-detail-pane" #detailPanel>
        <div class="ce-state" *ngIf="!selectedOu">
          <i class="pi pi-arrow-circle-right ce-state-icon"></i>
          <p>{{ 'Select a unit to manage its experts' | translator }}</p>
        </div>

        <ng-container *ngIf="selectedOu as ou">
          <div class="ce-detail-header">
            <div class="ce-detail-title">
              <span class="ce-ou-avatar ce-ou-avatar-lg">
                <img *ngIf="checkisImg(ou.image); else ouIconLg" [src]="staticURL + ou.image" alt="" />
                <ng-template #ouIconLg><i class="{{ ou.image || 'pi pi-building' }}"></i></ng-template>
              </span>
              <div>
                <h3>{{ ou.label }}</h3>
                <span class="ce-ou-path" *ngIf="ou.path">{{ ou.path }}</span>
              </div>
            </div>
            <button *ngIf="canAdd" type="button" class="ce-btn ce-btn-primary" (click)="openPicker()">
              <i class="pi pi-user-plus"></i>{{ 'Add expert' | translator }}
            </button>
          </div>

          <!-- Assigned -->
          <div class="ce-section">
            <div class="ce-section-head">
              <h4><i class="pi pi-verified"></i>{{ 'Assigned report experts' | translator }}
                <span class="ce-badge">{{ ou.assigned.length }}</span></h4>
              <span class="ce-hint">{{ 'Shown in the report expert list and allowed to sign this unit reports' | translator }}</span>
            </div>

            <div class="ce-empty-inline" *ngIf="ou.assigned.length === 0">
              <i class="pi pi-exclamation-triangle"></i>
              <div>
                <strong>{{ 'No report experts yet' | translator }}</strong>
                <span>{{ 'Reports for this unit cannot be sent to an expert until one is assigned.' | translator }}</span>
              </div>
            </div>

            <ul class="ce-people" *ngIf="ou.assigned.length > 0">
              <li *ngFor="let a of ou.assigned; trackBy: trackById" class="ce-person ce-person-assigned"
                [class.ce-person-inactive]="!a.user?.isActive">
                <span class="ce-avatar">
                  <img *ngIf="a.user?.image && checkisImg(a.user?.image); else initialsA" [src]="staticURL + a.user?.image" alt="" />
                  <ng-template #initialsA>{{ initials(a.user?.fullName) }}</ng-template>
                </span>
                <span class="ce-person-text">
                  <span class="ce-person-name">
                    {{ a.user?.fullName || ('Deleted user' | translator) }}
                    <span class="ce-tag ce-tag-danger" *ngIf="!a.user">{{ 'Deleted' | translator }}</span>
                    <span class="ce-tag ce-tag-warn" *ngIf="a.user && !a.user.isActive">{{ 'Inactive' | translator }}</span>
                  </span>
                  <span class="ce-person-email" *ngIf="a.user?.email">{{ a.user?.email }}</span>
                  <span class="ce-person-meta" *ngIf="a.createdAt">{{ 'Assigned on' | translator }} {{ a.createdAt | date: 'dd-MM-yyyy' }}</span>
                </span>
                <span class="ce-person-actions" *ngIf="canChange || canRemove">
                  <button *ngIf="canChange" type="button" class="ce-icon-btn" (click)="openPicker(a)" [disabled]="isBusy('remove:' + a._id)"
                    [pTooltip]="'Change expert' | translator" tooltipPosition="top" [attr.aria-label]="'Change expert' | translator">
                    <i class="pi pi-sync"></i>
                  </button>
                  <button *ngIf="canRemove" type="button" class="ce-icon-btn ce-icon-btn-danger" (click)="confirmRemove(a)"
                    [disabled]="isBusy('remove:' + a._id)" [pTooltip]="'Remove expert' | translator" tooltipPosition="top"
                    [attr.aria-label]="'Remove expert' | translator">
                    <i class="pi" [ngClass]="isBusy('remove:' + a._id) ? 'pi-spin pi-spinner' : 'pi-trash'"></i>
                  </button>
                </span>
              </li>
            </ul>
          </div>

          <!-- Suggested -->
          <div class="ce-section">
            <div class="ce-section-head">
              <h4><i class="pi pi-lightbulb"></i>{{ 'Suggested experts' | translator }}
                <span class="ce-badge ce-badge-muted">{{ ou.suggested.length }}</span></h4>
              <span class="ce-hint">{{ 'Users of this unit whose role can approve content. Suggestions are not assigned until you add them.' | translator }}</span>
              <button *ngIf="canAdd && unassignedSuggestions.length > 1" type="button" class="ce-btn ce-btn-ghost ce-btn-sm"
                (click)="assignAllSuggested()" [disabled]="isBusy('assign-all:' + ou._id)">
                <i class="pi" [ngClass]="isBusy('assign-all:' + ou._id) ? 'pi-spin pi-spinner' : 'pi-check-square'"></i>
                {{ 'Assign all' | translator }} ({{ unassignedSuggestions.length }})
              </button>
            </div>

            <p class="ce-muted" *ngIf="ou.suggested.length === 0">{{ 'No suggestions for this unit. Use Add expert to search all users.' | translator }}</p>

            <ul class="ce-people" *ngIf="ou.suggested.length > 0">
              <li *ngFor="let s of ou.suggested; trackBy: trackById" class="ce-person ce-person-suggested">
                <span class="ce-avatar ce-avatar-muted">
                  <img *ngIf="s.image && checkisImg(s.image); else initialsS" [src]="staticURL + s.image" alt="" />
                  <ng-template #initialsS>{{ initials(s.fullName) }}</ng-template>
                </span>
                <span class="ce-person-text">
                  <span class="ce-person-name">{{ s.fullName }}</span>
                  <span class="ce-person-email">{{ s.email }}</span>
                </span>
                <span class="ce-person-actions">
                  <span class="ce-tag ce-tag-ok" *ngIf="s.isAssigned"><i class="pi pi-check"></i>{{ 'Assigned' | translator }}</span>
                  <button *ngIf="!s.isAssigned && canAdd" type="button" class="ce-btn ce-btn-outline ce-btn-sm"
                    (click)="assignSuggested(s)" [disabled]="isBusy('assign:' + ou._id + ':' + s._id)">
                    <i class="pi" [ngClass]="isBusy('assign:' + ou._id + ':' + s._id) ? 'pi-spin pi-spinner' : 'pi-plus'"></i>
                    {{ 'Assign' | translator }}
                  </button>
                </span>
              </li>
            </ul>
          </div>
        </ng-container>
      </section>
    </div>
  </div>
</div>

<!-- Add / change expert -->
<p-dialog [(visible)]="pickerVisible" [modal]="true" [draggable]="false" [resizable]="false" [dismissableMask]="true"
  [style]="{ width: 'min(620px, 94vw)' }" styleClass="ce-dialog"
  [header]="(pickerReplacing ? 'Change expert' : 'Add report experts') | translator">
  <div class="ce-picker" *ngIf="selectedOu">
    <p class="ce-muted mb-3">
      <ng-container *ngIf="pickerReplacing; else addHint">
        {{ 'Pick the user who replaces' | translator }} <strong>{{ pickerReplacing.user?.fullName || ('Deleted user' | translator) }}</strong>
        {{ 'for' | translator }} <strong>{{ selectedOu.label }}</strong>.
      </ng-container>
      <ng-template #addHint>
        {{ 'Search any active user and select one or more to assign to' | translator }} <strong>{{ selectedOu.label }}</strong>.
      </ng-template>
    </p>

    <div class="ce-search">
      <i class="pi" [ngClass]="pickerSearching ? 'pi-spin pi-spinner' : 'pi-search'" aria-hidden="true"></i>
      <input type="search" [ngModel]="pickerQuery" (ngModelChange)="onPickerQuery($event)"
        placeholder="{{ 'Search by name or email' | translator }}" [attr.aria-label]="'Search by name or email' | translator"
        autofocus />
    </div>

    <div class="ce-picked" *ngIf="pickerSelected.length > 0">
      <span class="ce-picked-chip" *ngFor="let u of pickerSelected">
        {{ u.fullName }}
        <button type="button" (click)="togglePick(u)" [attr.aria-label]="'Remove' | translator"><i class="pi pi-times"></i></button>
      </span>
    </div>

    <div class="ce-picker-results">
      <div class="ce-state ce-state-small" *ngIf="pickerSearchError">
        <i class="pi pi-exclamation-circle ce-state-icon ce-state-error"></i>
        <p>{{ 'Could not search users' | translator }}</p>
      </div>
      <div class="ce-state ce-state-small" *ngIf="!pickerSearchError && !pickerSearching && pickerResults.length === 0">
        <i class="pi pi-user-minus ce-state-icon"></i>
        <p>{{ 'No users found' | translator }}</p>
      </div>
      <button type="button" *ngFor="let u of pickerResults; trackBy: trackById" class="ce-person ce-person-pick"
        [class.picked]="isPicked(u)" [disabled]="isAlreadyAssigned(u)" (click)="togglePick(u)"
        [attr.aria-pressed]="isPicked(u)">
        <span class="ce-avatar">
          <img *ngIf="u.image && checkisImg(u.image); else initialsP" [src]="staticURL + u.image" alt="" />
          <ng-template #initialsP>{{ initials(u.fullName) }}</ng-template>
        </span>
        <span class="ce-person-text">
          <span class="ce-person-name">
            {{ u.fullName }}
            <span class="ce-tag ce-tag-info" *ngIf="isSuggested(u)">{{ 'Suggested' | translator }}</span>
          </span>
          <span class="ce-person-email">{{ u.email }}</span>
        </span>
        <span class="ce-person-actions">
          <span class="ce-tag ce-tag-ok" *ngIf="isAlreadyAssigned(u)"><i class="pi pi-check"></i>{{ 'Assigned' | translator }}</span>
          <i class="pi ce-pick-mark" *ngIf="!isAlreadyAssigned(u)" [ngClass]="isPicked(u) ? 'pi-check-circle' : 'pi-circle'"></i>
        </span>
      </button>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="ce-dialog-footer">
      <button type="button" class="ce-btn ce-btn-outline" (click)="pickerVisible = false">{{ 'Cancel' | translator }}</button>
      <button type="button" class="ce-btn ce-btn-primary" (click)="savePicker()"
        [disabled]="pickerSelected.length === 0 || isBusy('picker')">
        <i class="pi" [ngClass]="isBusy('picker') ? 'pi-spin pi-spinner' : 'pi-check'"></i>
        <ng-container *ngIf="pickerReplacing; else addLabel">{{ 'Save' | translator }}</ng-container>
        <ng-template #addLabel>{{ 'Assign' | translator }}<span *ngIf="pickerSelected.length > 1"> ({{ pickerSelected.length }})</span></ng-template>
      </button>
    </div>
  </ng-template>
</p-dialog>

<app-footer></app-footer>
